// カスタム



// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
const pagetopBtn = document.querySelector('#footer_to_top_btn');
pagetopBtn.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
});
};





// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});



  document.addEventListener("DOMContentLoaded", function () {
    function fixPrice(el) {
      const text = el.textContent;
      const match = text.match(/([\+－−]?)[¥]([\d,]+)\.(\d{2})/);
      if (!match) return;
      const sign = match[1];
      const yen = match[2].replace(/,/g, '');
      const decimals = match[3];
      const rounded = Math.round(parseFloat(yen + '.' + decimals));
      el.textContent = sign + rounded.toLocaleString('ja-JP');
    }

    // 初期読み込み分の処理
    document.querySelectorAll('.mw-text.mw-option__price').forEach(fixPrice);

    // 非同期に追加される場合にも対応（APOなど）
    const observer = new MutationObserver(mutations => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.mw-text.mw-option__price')) {
              fixPrice(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('.mw-text.mw-option__price').forEach(fixPrice);
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });